import { render } from "./StatsBoxes.vue?vue&type=template&id=7cbe9ef9&scoped=true&ts=true"
import script from "./StatsBoxes.vue?vue&type=script&lang=ts"
export * from "./StatsBoxes.vue?vue&type=script&lang=ts"

import "./StatsBoxes.vue?vue&type=style&index=0&id=7cbe9ef9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbe9ef9"]])

export default __exports__